import React from "react";
import { Image } from "react-bootstrap";
import { checkLogoLogictics, convertLogicticsName } from "../../helpers";
import { billDeliveryKey, billManualCarrierName } from "./billDestination";

//* ໂລໂກ້ຂົນສົ່ງໃນບິນ — ຂົນສົ່ງທີ່ຮ້ານພິມເອງບໍ່ມີໂລໂກ້ ຈຶ່ງສະແດງຊື່ທີ່ພິມໃນວົງມົນຂະໜາດດຽວກັນແທນ
//* (ເມື່ອກ່ອນ checkLogoLogictics ຄືນໂລໂກ້ HAL ໃຫ້ຊື່ທີ່ບໍ່ຮູ້ຈັກ)
const BillCarrierMark = ({ item, imageStyle, captionSize }) => {
  const manualName = billManualCarrierName(item);
  const deliveryKey = billDeliveryKey(item);
  if (!manualName && !deliveryKey) return null;

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      {manualName ? (
        <div
          style={{
            ...imageStyle,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: 8,
            overflow: "hidden",
            wordBreak: "break-word",
            fontSize: manualName.length > 12 ? 20 : 26,
            fontWeight: "bold",
            lineHeight: 1.2,
          }}
        >
          {manualName}
        </div>
      ) : (
        <Image src={checkLogoLogictics(deliveryKey)} style={imageStyle} roundedCircle />
      )}
      <p style={{ fontSize: captionSize }}>
        {manualName ? "ຂົນສົ່ງ" : `${convertLogicticsName(deliveryKey)} ຂົນສົ່ງດ່ວນ`}
      </p>
    </div>
  );
};

export default BillCarrierMark;
